"use client";
import Link from "next/link";
import React from "react";

import { useT } from "@/context/I18nContext";

export default function Nav({ isAdmin }) {
	const { t } = useT();

	return (
		<>
                    <style jsx>{`
               .pulse-link {
                    animation: pulseLink 1.5s infinite ease-in-out;
               }

               @keyframes pulseLink {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
               }
               `}</style>
		
			<li className="menu-item" style={{ paddingLeft: 71 }}>
				<Link href="/" className="item-link">
					<i
						className="icon icon-home"
						style={{ fontSize: 18, display: "inline-block", width: "1em", textAlign: "center" }}
					/>{" "}
					{t('acasa')}
				</Link>
			</li>
               <li className="menu-item">
				<Link href="/toate-produsele" className="item-link">
					<i
						className="icon icon-bag"
						style={{ fontSize: 18, display: "inline-block", width: "1em", textAlign: "center" }}
					/>{" "}
					{t('magazin')}
				</Link>
			</li>
               <li className="menu-item">
				<Link href="/reduceri" className="item-link pulse-link" style={{ color: '#B00020' }}>
					<i
						className="icon icon-energy"
						style={{ fontSize: 18, display: "inline-block", width: "1em", textAlign: "center" }}
					/>{" "}
					{t('reduceri')}
				</Link>
			</li>
			<li className="menu-item">
				<Link href="/contact" className="item-link">
					<i
						className="icon icon-mail"
						style={{ fontSize: 16, display: "inline-block", width: "1em", textAlign: "center" }}
					></i>{" "}
					Contact
				</Link>
			</li>
			{isAdmin && (
				<li className="menu-item">
					<Link
						href="/admin"
						className="item-link"
						style={{
							backgroundColor: "#B00020",
							color: "#fff",
							padding: "6px 14px",
							borderRadius: 20,
						}}>
						<i
							className="icon icon-user"
							style={{ fontSize: 16, display: "inline-block", width: "1em", textAlign: "center" }}
						></i>{" "}
						{t("admin_panou")}
					</Link>
				</li>
			)}
		</>
	);
}
